import React, { useState } from 'react'
import { Typography, TextField, Button } from '@material-ui/core';
import { setSnackInfo, setLoading } from '../../redux/actions/appAction';
import { connect, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';
import HttpService from '../../services/httpService';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  input: {
    color: "white",
    borderBottom: "1px solid #fff",
  },
  inputLabel: {
    color: "#aca9a9 !important",
  },
  icon: {
    color: 'white',
  },
  sendPasswordButton: { backgroundColor: 'white', marginTop: '10%', color: '#2c2e3e', margin: 'center', padding: 5, borderRadius: '50px', width: '100px', "&:hover": { backgroundColor: "#3f51b5", color: 'white' } },
});

const AgentStatus = (props) => {

  const classes = useStyles();

  const { userDetails } = useSelector(state => state.user)
  
  const history = useHistory()

  const confirmAgentLogin = async () => {
  
    props.setLoading(true)
  
    try {
      const AgentStatus = await HttpService.agentStatus()
      let isAgentAvailable = AgentStatus.data.agent_status == 'Available'
      if(isAgentAvailable) {
          history.push('/call_center_dashboard');
      } else {
        props.setSnackInfo('Kindly login Voice Excel!', "error")
      }
  
    } catch (error) {
  
      console.error(error)
  
      props.setSnackInfo(error?.response?.data?.message || error?.response?.data || "Something went wrong", "error")
  
    }
  
    props.setLoading(false)
  
  }

  const handleLogout = async () => {
    props.setLoading(true)
    try {
      let reload = userDetails.roles.find(role => role.name == 'TeleCaller' || role.name == 'TeleCallerAssistantManager')
      localStorage.clear()
      // props.setUserDetails({})
      history.push('/');
      reload && window.location.reload()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "25vh" }}>
      
      <div>
      
        <Typography variant="h4" gutterBottom>
          Please login Voice Excel & click to confirm
        </Typography>
      
        <div style={{ margin: 20 }}></div>
      
        <div>
      
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
      
            <Button style={{marginRight: 5}} variant="contained" color="primary" onClick={confirmAgentLogin}>
              Confirm
            </Button>
            <Button variant="contained" color="primary" onClick={handleLogout}>
              Logout
            </Button>
      
          </div>
      
        </div>
      
      </div>
    
    </div>
  )
}

export default connect(null, { setLoading, setSnackInfo })(AgentStatus)
